/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useState, useEffect, useRef } from "react";

const PhoneActionMenu = ({ phone }) => {
  const { t: uiT } = useUiTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const menuRef = useRef(null);

  const handleCopyPhone = async (phoneNumber, targetElement) => {
    const showSuccessNotification = (element) => {
      const rect = element.getBoundingClientRect();

      const successMsg = document.createElement("div");
      successMsg.innerHTML = "✅ تم النسخ بنجاح!";
      successMsg.style.cssText = `
        position: fixed;
        top: ${rect.bottom + 10}px;
        left: ${rect.left + rect.width / 2}px;
        transform: translateX(-50%);
        background: linear-gradient(135deg, #4CAF50, #45a049);
        color: white;
        padding: 12px 20px;
        border-radius: 25px;
        font-size: 14px;
        font-weight: bold;
        z-index: 9999;
        direction: rtl;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
        border: 2px solid rgba(255, 255, 255, 0.3);
        animation: copySuccess 0.6s ease-out;
        white-space: nowrap;
      `;

      if (!document.getElementById("copy-success-animation")) {
        const style = document.createElement("style");
        style.id = "copy-success-animation";
        style.textContent = `
          @keyframes copySuccess {
            0% {
              opacity: 0;
              transform: translateX(-50%) translateY(-10px) scale(0.8);
            }
            50% {
              opacity: 1;
              transform: translateX(-50%) translateY(0) scale(1.05);
            }
            100% {
              opacity: 1;
              transform: translateX(-50%) translateY(0) scale(1);
            }
          }
          @keyframes copyFadeOut {
            0% {
              opacity: 1;
              transform: translateX(-50%) translateY(0) scale(1);
            }
            100% {
              opacity: 0;
              transform: translateX(-50%) translateY(-10px) scale(0.9);
            }
          }
        `;
        document.head.appendChild(style);
      }

      document.body.appendChild(successMsg);

      setTimeout(() => {
        successMsg.style.animation = "copyFadeOut 0.3s ease-in forwards";
        setTimeout(() => {
          if (document.body.contains(successMsg)) {
            document.body.removeChild(successMsg);
          }
        }, 300);
      }, 1700);
    };

    try {
      await navigator.clipboard.writeText(phoneNumber);
      showSuccessNotification(targetElement);
    } catch (err) {
      console.error("Failed to copy: ", err);
      const textArea = document.createElement("textarea");
      textArea.value = phoneNumber;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);

      showSuccessNotification(targetElement);
    }
  };

  const handlePhoneClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const rect = event.currentTarget.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const menuHeight = 120;

    const shouldShowAbove = rect.bottom + menuHeight > viewportHeight;

    setMenuPosition({
      top: shouldShowAbove ? rect.top - menuHeight - 10 : rect.bottom + 10,
      left: rect.left + rect.width / 2,
    });

    setShowMenu(true);
  };

  const handleCall = () => {
    window.location.href = `tel:${phone}`;
    setShowMenu(false);
  };

  const handleCopy = async () => {
    await handleCopyPhone(phone, menuRef.current);
    setShowMenu(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [showMenu]);

  useEffect(() => {
    if (!document.getElementById("iphone-menu-styles")) {
      const style = document.createElement("style");
      style.id = "iphone-menu-styles";
      style.textContent = `
        .iphone-action-menu {
          position: fixed;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border-radius: 14px;
          padding: 8px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
          z-index: 9998;
          transform: translateX(-50%);
          min-width: 200px;
          border: 0.5px solid rgba(0, 0, 0, 0.08);
          animation: menuSlideIn 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        @keyframes menuSlideIn {
          from {
            opacity: 0;
            transform: translateX(-50%) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) scale(1);
          }
        }

        .iphone-menu-item {
          display: flex;
          align-items: center;
          padding: 12px 16px;
          cursor: pointer;
          border-radius: 8px;
          transition: background-color 0.2s ease;
          margin-bottom: 4px;
          direction: rtl;
        }

        .iphone-menu-item:last-child {
          margin-bottom: 0;
        }

        .iphone-menu-item:hover {
          background-color: rgba(0, 0, 0, 0.05);
        }

        .iphone-menu-item:active {
          background-color: rgba(0, 0, 0, 0.1);
          transform: scale(0.98);
        }

        .iphone-menu-icon {
          width: 24px;
          height: 24px;
          margin-left: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
        }

        .iphone-menu-text {
          font-size: 15px;
          color: #000;
          font-weight: 400;
          flex: 1;
        }

        .iphone-menu-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: transparent;
          z-index: 9997;
        }

        .phone-number-trigger {
          color: #007AFF;
          cursor: pointer;
          text-decoration: none;
          font-weight: 500;
          transition: opacity 0.2s ease;
          -webkit-tap-highlight-color: transparent;
        }

        .phone-number-trigger:hover {
          opacity: 0.7;
        }

        .phone-number-trigger:active {
          opacity: 0.5;
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <>
      <span
        className="phone-number-trigger"
        onClick={handlePhoneClick}
        title={uiT("ui.phoneOptions")}
      >
        {phone}
      </span>

      {showMenu && (
        <>
          <div
            className="iphone-menu-overlay"
            onClick={() => setShowMenu(false)}
          />
          <div
            ref={menuRef}
            className="iphone-action-menu"
            style={{
              top: `${menuPosition.top}px`,
              left: `${menuPosition.left}px`,
            }}
          >
            <div className="iphone-menu-item" onClick={handleCall}>
              <div className="iphone-menu-icon">📞</div>
              <div className="iphone-menu-text">{uiT("ui.call")}</div>
            </div>
            <div className="iphone-menu-item" onClick={handleCopy}>
              <div className="iphone-menu-icon">📋</div>
              <div className="iphone-menu-text">{uiT("ui.copyPhone")}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PhoneActionMenu;
